import { isPossiblePhoneNumber } from 'libphonenumber-js';

const removeWhitespaces = (str: string): string => str.replace(/\s+/g, '');

/**
 * Cleans a phone number by removing whitespaces and ensuring it is in E.164 format.
 * @param phoneDirty - phone number in any format
 * @returns cleaned phone number in E.164 format or undefined if input is invalid
 */
export const cleanPhoneNumber = (phoneDirty: unknown): string | undefined => {
  let phone =
    typeof phoneDirty === 'string' ? removeWhitespaces(phoneDirty) : undefined;

  if (phone === undefined || phone.length <= 0) {
    return undefined;
  }

  if (!phone.startsWith('+')) {
    phone = `+${phone}`;
  }

  return isPossiblePhoneNumber(phone) ? phone : undefined;
};
